// import VT from '@/store/types';

export default {
  // [VT.LABEL_SET_TAGS_LIST]: (state, { data, status }) => {
  //   state.labelSetTagsList = { data, status };
  // },
};
